import { render, staticRenderFns } from "./VideoPlayerVOD.vue?vue&type=template&id=0cb59c66&scoped=true&"
import script from "./VideoPlayerVOD.vue?vue&type=script&lang=js&"
export * from "./VideoPlayerVOD.vue?vue&type=script&lang=js&"
import style0 from "./VideoPlayerVOD.vue?vue&type=style&index=0&lang=css&"
import style1 from "./VideoPlayerVOD.vue?vue&type=style&index=1&id=0cb59c66&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb59c66",
  null
  
)

export default component.exports